import React from 'react';
import './nfdProductsLogosSection.scss';
import NfdProductsLogosItemComponent from "./components/NfdProductsLogosItemComponent";
import { ReactComponent as PurplePlatform } from "./icons/purple/PurplePlatform.svg";
import { ReactComponent as NativePlatform } from "./icons/native/NativePlatform.svg";
import { ReactComponent as WhitePlatform } from "./icons/white/WhitePlatform.svg";
import { ReactComponent as BlackPlatform } from "./icons/black/BlackPlatform.svg";

import { ReactComponent as PurpleCombine } from "./icons/purple/PurpleCombine.svg";
import { ReactComponent as NativeCombine } from "./icons/native/NativeCombine.svg";
import { ReactComponent as WhiteCombine } from "./icons/white/WhiteCombine.svg";
import { ReactComponent as BlackCombine } from "./icons/black/BlackCombine.svg";

import { ReactComponent as PurpleSomething } from "./icons/purple/PurpleSomething.svg";
import { ReactComponent as NativeSomething } from "./icons/native/NativeSomething.svg";
import { ReactComponent as WhiteSomething } from "./icons/white/WhiteSomething.svg";
import { ReactComponent as BlackSomething } from "./icons/black/BlackSomething.svg";

import { ReactComponent as PurpleCoolDEX } from "./icons/purple/PurpleCoolDEX.svg";
import { ReactComponent as NativeCoolDEX } from "./icons/native/NativeCoolDEX.svg";
import { ReactComponent as WhiteCoolDEX } from "./icons/white/WhiteCoolDEX.svg";
import { ReactComponent as BlackCoolDEX } from "./icons/black/BlackCoolDEX.svg";

import { ReactComponent as PurpleTrading } from "./icons/purple/PurpleTrading.svg";
import { ReactComponent as NativeTrading } from "./icons/native/NativeTrading.svg";
import { ReactComponent as WhiteTrading } from "./icons/white/WhiteTrading.svg";
import { ReactComponent as BlackTrading } from "./icons/black/BlackTrading.svg";

const NfdProductsLogosSection = () => {
	return (
		<div className="nfdProductsLogos">
			<div className="stars"></div>
			<div className="stars2"></div>
			<div className="stars3"></div>
			<div className="nfdProductsLogos__content">
				<div className="nfdProductsLogos__content_data">
					<div className="stars"></div>
					<div className="stars2"></div>
					<div className="stars3"></div>
					<div className="nfdProductsLogos__content_data_title">
						<h2>NFD Products Logos</h2>
						<span>NFD products logos are displayed in the official colors and usage patterns</span>
					</div>
					<div className="nfdProductsLogos__content_data_button">
						<button
							className="secondButton"
							onClick={() => {}}
						>
							<span>Download All Logos</span>
						</button>
					</div>
				</div>
				<div className="nfdProductsLogos__content_icons">
					<NfdProductsLogosItemComponent
						type={'NfdPlatform'}
						title={'NFD Platform'}
						purple={<PurplePlatform />}
						native={<NativePlatform />}
						white={<WhitePlatform />}
						black={<BlackPlatform />}
					/>
					<NfdProductsLogosItemComponent
						type={'NfdCombine'}
						title={'NFD Combine'}
						purple={<PurpleCombine />}
						native={<NativeCombine />}
						white={<WhiteCombine />}
						black={<BlackCombine />}
					/>
					<NfdProductsLogosItemComponent
						type={'SomethingCool'}
						title={'Something Cool'}
						purple={<PurpleSomething />}
						native={<NativeSomething />}
						white={<WhiteSomething />}
						black={<BlackSomething />}
					/>
					<NfdProductsLogosItemComponent
						type={'CoolDEX'}
						title={'CoolDEX'}
						purple={<PurpleCoolDEX />}
						native={<NativeCoolDEX />}
						white={<WhiteCoolDEX />}
						black={<BlackCoolDEX />}
					/>
					<NfdProductsLogosItemComponent
						type={'NfdTradingBots'}
						title={'NFD Trading Bots'}
						purple={<PurpleTrading />}
						native={<NativeTrading />}
						white={<WhiteTrading />}
						black={<BlackTrading />}
					/>
				</div>
			</div>
		</div>
	);
};

export default NfdProductsLogosSection;